import React from 'react';
import PropTypes from 'prop-types';

import { Bert } from 'meteor/themeteorchef:bert';
import { isEmpty } from 'lodash';
import { Meteor } from 'meteor/meteor';
import { withTracker } from 'meteor/react-meteor-data';
import {
  Box,
  Checkbox,
  Divider,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography
} from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PlagiarismOutlinedIcon from '@mui/icons-material/PlagiarismOutlined';
import SaveIcon from '@mui/icons-material/Save';
import ShareIcon from '@mui/icons-material/Share';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AnnotationTemplatesCollection, {
  LIBRARY_ICON_TYPES
} from '../../../api/AnnotationTemplates/AnnotationTemplates';
import Projects from '../../../api/Projects/Projects';
import Videos from '../../../api/Videos/Videos';
import ShowListIconsFontawesome from '../../components/ShowListIconsFontawesome';
import TemplateConfigLocationModal from '../TemplateConfigLocationModal';
import RouteConfiguration from '../RouteConfiguration';

import * as videoOps from '../../../api/Videos/video-operations';
import * as templateOps from '../../../api/AnnotationTemplates/annotation-template-operations';

const MapsAdvancedLocationField = props => {
  const {
    listComponentsAdvanced,
    loading,
    projectList,
    setListComponentsAdvanced,
    setSettingsAdvanced,
    settingsAdvanced,
    videoList,
    setSizeDrawer,
    annotationTemplateCustomList
  } = props;
  const {
    image,
    intervalTime,
    projectId,
    savingSystem,
    videoId
  } = settingsAdvanced.locationSettings;

  const [localSettings, setLocalSettings] = React.useState(settingsAdvanced.locationSettings);
  const [iconFontawesome, setIconFontawesome] = React.useState(
    listComponentsAdvanced.LocationComponent.iconFontawesome
  );
  const [iconSvg, setIconSvg] = React.useState(listComponentsAdvanced.LocationComponent.iconSvg);
  const ImageInputRef = React.useRef(null);
  const [imageState, setImageState] = React.useState(image);
  const [intervalTimeLocal, setIntervalTimeLocal] = React.useState(intervalTime);
  const [libraryIcon, setLibraryIcon] = React.useState(
    listComponentsAdvanced.LocationComponent.libraryIcon
  );
  const [nameComponent, setNameComponent] = React.useState(
    listComponentsAdvanced.LocationComponent.name
  );
  const [systemSelected, setSystemSelected] = React.useState(savingSystem);
  const [openModal, setOpenModal] = React.useState(false);
  const [openModalCurrentButton, setOpenModalCurrentButton] = React.useState(false);
  const [openModalIframeButton, setOpenModalIframeButton] = React.useState(false);
  const [openModalImageButton, setOpenModalImageButton] = React.useState(false);
  const [openModalVideoButton, setOpenModalVideoButton] = React.useState(false);

  const [annotationState, setAnnotationState] = React.useState(false);
  const [functionState, setFunctionState] = React.useState(false);
  const [styleState, setStyleState] = React.useState(false);
  const typeComponentOptions = [
    {
      labelName: 'Send only the location',
      value: 'Simple'
    },
    {
      labelName: 'Send information without map',
      value: 'MediumWithout'
    },
    {
      labelName: 'Send information with map',
      value: 'MediumWith'
    },
    {
      labelName: 'Custom component',
      value: 'Complex'
    }
  ];

  const savingSystemOptions = [
    {
      name: 'Tiempo incremental',
      value: 'incremental'
    },
    {
      name: 'Localización más cercana',
      value: 'location'
    },
    {
      name: 'Tiempo gps',
      value: 'gpsTime'
    }
  ];

  const [projectSelect, setProjectSelect] = React.useState(() => {
    if (!loading && !isEmpty(projectId)) {
      return projectList.find(item => item._id === projectId) || {};
    }
    return {};
  });

  const [videoSelect, setVideoSelect] = React.useState(() => {
    if (!loading && !isEmpty(videoId)) {
      return videoList.find(item => item._id === videoId) || {};
    }
    return {};
  });

  const [videosFromProject, setVideosFromProject] = React.useState(() => {
    if (!loading && !isEmpty(projectId)) {
      return videoList.filter(item => item.project === projectId);
    }
    return [];
  });
  const templatesToRender = !isEmpty(videoSelect)
    ? videoSelect.annotationTemplates.concat(annotationTemplateCustomList)
    : [];
  const handleIconSelected = (elementIcon, library) => {
    if (library === LIBRARY_ICON_TYPES.FONTAWESOME) {
      setIconFontawesome(elementIcon);
      setListComponentsAdvanced({
        ...listComponentsAdvanced,
        LocationComponent: {
          name: listComponentsAdvanced.LocationComponent.name,
          show: listComponentsAdvanced.LocationComponent.show,
          iconFontawesome: elementIcon,
          libraryIcon: library
        }
      });
    }

    if (library === LIBRARY_ICON_TYPES.SVG) {
      setIconSvg(elementIcon.url);
      setIconFontawesome(elementIcon.name);
      setListComponentsAdvanced({
        ...listComponentsAdvanced,
        LocationComponent: {
          name: listComponentsAdvanced.LocationComponent.name,
          show: listComponentsAdvanced.LocationComponent.show,
          iconFontawesome: elementIcon.name,
          iconSvg: elementIcon.url,
          libraryIcon: library,
          cetegorySvg: elementIcon.category
        }
      });
    }
    setLibraryIcon(library);
  };

  const handleChangeInterval = value => {
    if (value === '') {
      setIntervalTimeLocal('');
      setSettingsAdvanced(prev => ({
        ...prev,
        locationSettings: {
          ...prev.locationSettings,
          intervalTime: ''
        }
      }));
    } else if (Number.isNaN(value) || value < 0) {
      Bert.alert('You need to enter a valid number for the interval', 'danger');
    } else {
      setIntervalTimeLocal(value);
      setSettingsAdvanced(prev => ({
        ...prev,
        locationSettings: {
          ...prev.locationSettings,
          intervalTime: value
        }
      }));
    }
  };

  const loadFileToBack = async file => {
    let firstAnswer = {};

    const formData = new FormData();
    formData.append('file', file);
    formData.append('disc', 'data3');

    try {
      const response = await fetch('https://sd1.d3.ipsilum.com/upload', {
        method: 'POST',
        body: formData,
        mode: 'cors',
        credentials: 'omit',
        referrerPolicy: 'no-referrer'
      });

      firstAnswer = await response.json();
      setSettingsAdvanced(prev => ({
        ...prev,
        locationSettings: {
          ...prev.locationSettings,
          image: firstAnswer.data.link
        }
      }));
      setImageState(firstAnswer.data.link);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleProject = async event => {
    const newProject = projectList.find(element => element.name === event.target.value);
    setProjectSelect(newProject);

    const newVideosFromProject = videoList.filter(item => item.project === newProject._id);
    setVideosFromProject(newVideosFromProject);

    setSettingsAdvanced(prev => ({
      ...prev,
      locationSettings: {
        ...prev.locationSettings,
        projectId: newProject._id
      }
    }));
  };

  const handleIconToAddImageSelected = (elementIcon, library) => {
    if (library === LIBRARY_ICON_TYPES.FONTAWESOME) {
      setLocalSettings({
        ...localSettings,
        buttonToAddImage: {
          ...localSettings.buttonToAddImage,
          iconFontawesome: elementIcon,
          libraryIcon: library
        }
      });
      setSettingsAdvanced(prev => ({
        ...prev,
        locationSettings: {
          ...prev.locationSettings,
          buttonToAddImage: {
            ...prev.locationSettings.buttonToAddImage,
            iconFontawesome: elementIcon,
            libraryIcon: library
          }
        }
      }));
    } else if (library === LIBRARY_ICON_TYPES.SVG) {
      setLocalSettings({
        ...localSettings,
        buttonToAddImage: {
          ...localSettings.buttonToAddImage,
          iconFontawesome: elementIcon.name,
          iconSvg: elementIcon.url,
          libraryIcon: library,
          cetegorySvg: elementIcon.category
        }
      });
      setSettingsAdvanced(prev => ({
        ...prev,
        locationSettings: {
          ...prev.locationSettings,
          buttonToAddImage: {
            ...prev.locationSettings.buttonToAddImage,
            iconFontawesome: elementIcon.name,
            iconSvg: elementIcon.url,
            libraryIcon: library,
            cetegorySvg: elementIcon.category
          }
        }
      }));
    } else {
      setLocalSettings({
        ...localSettings,
        buttonToAddImage: {
          ...localSettings.buttonToAddImage,
          libraryIcon: library
        }
      });
    }
  };

  const handleIconToAddVideoSelected = (elementIcon, library) => {
    if (library === LIBRARY_ICON_TYPES.FONTAWESOME) {
      setLocalSettings({
        ...localSettings,
        buttonToAddVideo: {
          ...localSettings.buttonToAddVideo,
          iconFontawesome: elementIcon,
          libraryIcon: library
        }
      });
      setSettingsAdvanced(prev => ({
        ...prev,
        locationSettings: {
          ...prev.locationSettings,
          buttonToAddVideo: {
            ...prev.locationSettings.buttonToAddVideo,
            iconFontawesome: elementIcon,
            libraryIcon: library
          }
        }
      }));
    } else if (library === LIBRARY_ICON_TYPES.SVG) {
      setLocalSettings({
        ...localSettings,
        buttonToAddVideo: {
          ...localSettings.buttonToAddVideo,
          iconFontawesome: elementIcon.name,
          iconSvg: elementIcon.url,
          libraryIcon: library,
          cetegorySvg: elementIcon.category
        }
      });
      setSettingsAdvanced(prev => ({
        ...prev,
        locationSettings: {
          ...prev.locationSettings,
          buttonToAddVideo: {
            ...prev.locationSettings.buttonToAddVideo,
            iconFontawesome: elementIcon.name,
            iconSvg: elementIcon.url,
            libraryIcon: library,
            cetegorySvg: elementIcon.category
          }
        }
      }));
    } else {
      setLocalSettings({
        ...localSettings,
        buttonToAddVideo: {
          ...localSettings.buttonToAddVideo,
          libraryIcon: library
        }
      });
    }
  };

  const handleIconToAddIframeSelected = (elementIcon, library) => {
    if (library === LIBRARY_ICON_TYPES.FONTAWESOME) {
      setLocalSettings({
        ...localSettings,
        buttonToAddIframe: {
          ...localSettings.buttonToAddIframe,
          iconFontawesome: elementIcon,
          libraryIcon: library
        }
      });
      setSettingsAdvanced(prev => ({
        ...prev,
        locationSettings: {
          ...prev.locationSettings,
          buttonToAddIframe: {
            ...prev.locationSettings.buttonToAddIframe,
            iconFontawesome: elementIcon,
            libraryIcon: library
          }
        }
      }));
    } else if (library === LIBRARY_ICON_TYPES.SVG) {
      setLocalSettings({
        ...localSettings,
        buttonToAddIframe: {
          ...localSettings.buttonToAddIframe,
          iconFontawesome: elementIcon.name,
          iconSvg: elementIcon.url,
          libraryIcon: library,
          cetegorySvg: elementIcon.category
        }
      });
      setSettingsAdvanced(prev => ({
        ...prev,
        locationSettings: {
          ...prev.locationSettings,
          buttonToAddIframe: {
            ...prev.locationSettings.buttonToAddIframe,
            iconFontawesome: elementIcon.name,
            iconSvg: elementIcon.url,
            libraryIcon: library,
            cetegorySvg: elementIcon.category
          }
        }
      }));
    } else {
      setLocalSettings({
        ...localSettings,
        buttonToAddIframe: {
          ...localSettings.buttonToAddIframe,
          libraryIcon: library
        }
      });
    }
  };

  const handleIconCurrentLocationSelected = (elementIcon, library) => {
    if (library === LIBRARY_ICON_TYPES.FONTAWESOME) {
      setLocalSettings({
        ...localSettings,
        buttonCurrentLocation: {
          ...localSettings.buttonCurrentLocation,
          iconFontawesome: elementIcon,
          libraryIcon: library
        }
      });
      setSettingsAdvanced(prev => ({
        ...prev,
        locationSettings: {
          ...prev.locationSettings,
          buttonCurrentLocation: {
            ...prev.locationSettings.buttonCurrentLocation,
            iconFontawesome: elementIcon,
            libraryIcon: library
          }
        }
      }));
    } else if (library === LIBRARY_ICON_TYPES.SVG) {
      setLocalSettings({
        ...localSettings,
        buttonCurrentLocation: {
          ...localSettings.buttonCurrentLocation,
          iconFontawesome: elementIcon.name,
          iconSvg: elementIcon.url,
          libraryIcon: library,
          cetegorySvg: elementIcon.category
        }
      });
      setSettingsAdvanced(prev => ({
        ...prev,
        locationSettings: {
          ...prev.locationSettings,
          buttonCurrentLocation: {
            ...prev.locationSettings.buttonCurrentLocation,
            iconFontawesome: elementIcon.name,
            iconSvg: elementIcon.url,
            libraryIcon: library,
            cetegorySvg: elementIcon.category
          }
        }
      }));
    } else {
      setLocalSettings({
        ...localSettings,
        buttonCurrentLocation: {
          ...localSettings.buttonCurrentLocation,
          libraryIcon: library
        }
      });
    }
  };

  const renderField = (type, variable, normalName) => {
    switch (type) {
      case 'checkBox':
        return (
          <Box display="row" justifyContent="space-evenly" fullwidth="true" mb={2}>
            <Checkbox
              checked={localSettings[variable]}
              onChange={() => {
                setSettingsAdvanced(prev => ({
                  ...prev,
                  locationSettings: {
                    ...prev.locationSettings,
                    [variable]: !localSettings[variable]
                  }
                }));
                setLocalSettings({
                  ...localSettings,
                  [variable]: !localSettings[variable]
                });
              }}
              sx={{
                color: '#2A3F90',
                '&.Mui-checked': {
                  color: '#2A3F90'
                }
              }}
              value="variable"
            />
            {normalName}
          </Box>
        );
      case 'TextField':
        return (
          <Box display="flex" justifyContent="space-evenly" width="100%" mb={2}>
            <TextField
              id="outlined-required"
              label={normalName}
              size="small"
              value={localSettings[variable]}
              onChange={event => {
                setSettingsAdvanced(prev => ({
                  ...prev,
                  locationSettings: {
                    ...prev.locationSettings,
                    [variable]: event.target.value
                  }
                }));
                setLocalSettings({
                  ...localSettings,
                  [variable]: event.target.value
                });
              }}
              mb={2}
              fullWidth
            />
          </Box>
        );
      case 'TextFieldNumber':
        return (
          <Box display="row" justifyContent="space-evenly" fullwidth="true" mb={2}>
            <TextField
              id="outlined-required"
              label={normalName}
              size="small"
              type="number"
              value={localSettings[variable]}
              onChange={event => {
                const { value } = event.target;
                if (value !== '' && Number(value) > 0) {
                  setSettingsAdvanced(prev => ({
                    ...prev,
                    locationSettings: {
                      ...prev.locationSettings,
                      [variable]: Number(value)
                    }
                  }));
                }
                setLocalSettings({
                  ...localSettings,
                  [variable]: Number(value)
                });
              }}
              inputProps={{ min: 1 }}
              mb={2}
              fullWidth
            />
          </Box>
        );
      default:
        return <Box display="row" justifyContent="space-evenly" fullwidth="true" mb={2} />;
    }
  };

  const handleTemplateConfiguration = newConfig => {
    setSettingsAdvanced(prev => ({
      ...prev,
      locationSettings: {
        ...prev.locationSettings,
        templateConfiguration: newConfig
      }
    }));
    setLocalSettings({
      ...localSettings,
      templateConfiguration: newConfig
    });
  };

  const handleRouteConfiguration = newConfig => {
    setSettingsAdvanced(prev => ({
      ...prev,
      locationSettings: {
        ...prev.locationSettings,
        createRouteConfiguration: newConfig
      }
    }));
    setLocalSettings({
      ...localSettings,
      createRouteConfiguration: newConfig
    });
  };

  React.useEffect(() => {
    if (!loading) {
      if (!isEmpty(projectId)) {
        const initialProject = projectList.find(item => item._id === projectId);
        setProjectSelect(initialProject);
        const initialVideosFromProject = videoList.filter(item => item.project === projectId);
        setVideosFromProject(initialVideosFromProject);
      }
      if (!isEmpty(videoId)) {
        const initialVideo = videoList.find(item => item._id === videoId);
        if (!isEmpty(initialVideo)) {
          setVideoSelect(initialVideo);
        }
      }
    }
  }, [loading]);

  return (
    <Box display="flex" width="100%" gab={1} justifyContent="space-around">
      <Box display="column" width="40%" gab={1} overflow="auto" maxHeight="75%">
        <Box
          component="form"
          sx={{
            display: 'flex',
            mb: 2,
            width: '100%'
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            id="outlined-required"
            label="Nombre del componente"
            size="small"
            value={nameComponent}
            onChange={event => setNameComponent(event.target.value)}
            mb={2}
            fullWidth
          />
          <IconButton
            onClick={() => setOpenModal(true)}
            style={{
              color: '#2A3F90'
            }}
          >
            {!isEmpty(libraryIcon) ? (
              <>
                {libraryIcon === LIBRARY_ICON_TYPES.FONTAWESOME && (
                  <FontAwesomeIcon icon={iconFontawesome} />
                )}
                {libraryIcon === LIBRARY_ICON_TYPES.SVG && (
                  <img
                    src={iconSvg}
                    alt={iconFontawesome}
                    style={{ marginRight: '5px', width: '20px', height: '20px' }}
                  />
                )}
              </>
            ) : (
              <ShareIcon />
            )}
          </IconButton>
          <IconButton
            onClick={() =>
              setListComponentsAdvanced({
                ...listComponentsAdvanced,
                LocationComponent: {
                  name: nameComponent,
                  show: listComponentsAdvanced.LocationComponent.show
                }
              })
            }
            style={{
              color: '#2A3F90'
            }}
          >
            <SaveIcon />
          </IconButton>
          <ShowListIconsFontawesome
            openModal={openModal}
            setOpenModal={setOpenModal}
            handleIconSelected={handleIconSelected}
            selectedIcon={listComponentsAdvanced.LocationComponent.iconFontawesome}
            startLibrary={listComponentsAdvanced.LocationComponent.libraryIcon}
            svg={listComponentsAdvanced.LocationComponent.iconSvg}
            startCategorySvg={listComponentsAdvanced.LocationComponent.cetegorySvg}
          />
        </Box>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="demo-select-label">Type of component</InputLabel>
          <Select
            labelId="demo-select-label"
            id="demo-select"
            label="Type of component"
            size="small"
            value={localSettings.typeComponent}
            onChange={event => {
              const newTemplateDefault =
                event.target.value === 'Simple' || event.target.value === 'MediumWithout'
                  ? 'baseTemplate3'
                  : 'baseTemplate2';
              if (newTemplateDefault === 'baseTemplate3') {
                setSizeDrawer({ name: '100%', value: 100 });
              } else {
                setSizeDrawer({ name: '50%', value: 50 });
              }
              setLocalSettings({
                ...localSettings,
                typeComponent: event.target.value
              });
              setSettingsAdvanced(prev => ({
                ...prev,
                locationSettings: {
                  ...prev.locationSettings,
                  typeComponent: event.target.value
                },
                buttonSettings: {
                  ...prev.buttonSettings,
                  templateDefault: newTemplateDefault
                }
              }));
            }}
          >
            {typeComponentOptions.map(item => (
              <MenuItem key={item.labelName} value={item.value}>
                {item.labelName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="demo-select-label">Proyecto</InputLabel>
          <Select
            labelId="demo-select-label"
            id="demo-select"
            label="Proyecto"
            size="small"
            value={projectSelect?.name || ''}
            onChange={handleProject}
          >
            {projectList.map(item => (
              <MenuItem key={item._id} value={item.name}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {!isEmpty(videosFromProject) && (
          <>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel id="demo-select-label">Vídeo</InputLabel>
              <Select
                labelId="demo-select-label"
                id="demo-select"
                label="Vídeo"
                size="small"
                value={videoSelect?.name || ''}
                onChange={async event => {
                  const video = videosFromProject.find(
                    element => element.name === event.target.value
                  );
                  if (video) {
                    setVideoSelect(video);
                    setLocalSettings({
                      ...localSettings,
                      defaultTemplate: video.annotationTemplates[0]._id
                    });
                    setSettingsAdvanced(prev => ({
                      ...prev,
                      locationSettings: {
                        ...prev.locationSettings,
                        videoId: video._id,
                        defaultTemplate: video.annotationTemplates[0]._id
                      }
                    }));
                  }
                }}
              >
                {videosFromProject.map(item => (
                  <MenuItem key={item._id} value={item.name}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {!isEmpty(videoSelect) && (
              <>
                <Box
                  component="form"
                  sx={{
                    display: 'flex',
                    mb: 2,
                    width: '100%'
                  }}
                  noValidate
                  autoComplete="off"
                >
                  <FormControl fullWidth>
                    <InputLabel id="demo-select-label">Plantilla por defecto</InputLabel>
                    <Select
                      labelId="demo-select-label"
                      id="demo-select"
                      label="Plantilla por defecto"
                      size="small"
                      value={localSettings.defaultTemplate}
                      onChange={e => {
                        setLocalSettings({
                          ...localSettings,
                          defaultTemplate: e.target.value
                        });
                        setSettingsAdvanced(prev => ({
                          ...prev,
                          locationSettings: {
                            ...prev.locationSettings,

                            defaultTemplate: e.target.value
                          }
                        }));
                      }}
                    >
                      {templatesToRender.map(item => (
                        <MenuItem key={item._id} value={item._id}>
                          {templateOps.getIsBase(item) ? item.name : `${item.name}-custom`}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>

                <TemplateConfigLocationModal
                  templateConfiguration={localSettings.templateConfiguration}
                  handleTemplateConfiguration={handleTemplateConfiguration}
                  videoSelect={videoSelect}
                  defaultTemplate={localSettings.defaultTemplate}
                />

                <Box display="flex" alignItems="center" width="100%" mb={2}>
                  <IconButton
                    onClick={() => {
                      setFunctionState(!functionState);
                    }}
                  >
                    {functionState ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                  </IconButton>
                  <Typography variant="body1" sx={{ marginRight: 2 }}>
                    Functions
                  </Typography>
                  <Divider sx={{ flexGrow: 1, height: 1, backgroundColor: 'grey' }} />
                </Box>
                {functionState === true && (
                  <>
                    {renderField('checkBox', 'showSharedButton', 'Show shared button')}
                    {renderField('checkBox', 'showCreateRouteOnMap', 'Show create route on map')}
                    {(localSettings.typeComponent === 'Complex' ||
                      localSettings.typeComponent === 'MediumWith') && (
                      <RouteConfiguration
                        createRouteConfiguration={localSettings.createRouteConfiguration}
                        handleRouteConfiguration={handleRouteConfiguration}
                        videoList={videoList}
                      />
                    )}

                    {localSettings.typeComponent === 'Complex' &&
                      renderField('TextFieldNumber', 'zoom', 'Zoom')}
                    {renderField('checkBox', 'showTracking', 'Show import tracking')}
                  </>
                )}

                {/* Teide --> mostrar en personalizable */}
                {localSettings.typeComponent === 'Complex' &&
                  renderField('checkBox', 'showAnnotation', 'Mostrar anotaciones')}
              </>
            )}
          </>
        )}
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="demo-simple-select-label">Saving system</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={systemSelected}
            label="Saving system"
            onChange={event => {
              setSystemSelected(event.target.value);
              setSettingsAdvanced(prev => ({
                ...prev,
                locationSettings: {
                  ...prev.locationSettings,
                  savingSystem: event.target.value
                }
              }));
            }}
            size="small"
          >
            {savingSystemOptions.map(item => (
              <MenuItem key={item.name} value={item.value}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {systemSelected === 'incremental' && (
          <Box display="flex" justifyContent="space-evenly" width="100%" mb={2}>
            <TextField
              id="outlined-required"
              label="Introduce un intervalo en segundos"
              size="small"
              value={intervalTimeLocal}
              onChange={event => handleChangeInterval(event.target.value)}
              mb={2}
              fullWidth
            />
          </Box>
        )}
      </Box>
      <Box display="column" width="40%" gab={1}>
        {/* Teide --> mostrar en todos */}
        <Box display="flex" alignItems="center" width="100%" mb={2}>
          <IconButton
            onClick={() => {
              setStyleState(!styleState);
            }}
          >
            {styleState ? <ExpandMoreIcon /> : <ExpandLessIcon />}
          </IconButton>
          <Typography variant="body1" sx={{ marginRight: 2 }}>
            Styles
          </Typography>
          <Divider sx={{ flexGrow: 1, height: 1, backgroundColor: 'grey' }} />
        </Box>
        {styleState === true && (
          <>
            {renderField('checkBox', 'showTitle', 'Show title')}
            {localSettings.showTitle === true && renderField('TextField', 'title', 'Enter a title')}
            {renderField('checkBox', 'showDescription', 'Show description')}
            {localSettings.showDescription === true &&
              renderField('TextField', 'description', 'Enter a description')}
            {/* Teide --> mostrar en personalizable */}
            {renderField('checkBox', 'showName', 'Show name')}
            {renderField(
              'checkBox',
              'userNameTitle',
              'The name of the annotation is the user name.'
            )}
            {/* Teide --> mostrar en personalizable */}
            {localSettings.typeComponent === 'Complex' &&
              renderField('checkBox', 'showImage', 'Show image')}
            {/* Teide --> mostrar en personalizable */}
            {localSettings.typeComponent === 'Complex' && localSettings.showImage === true && (
              <Box
                component="form"
                sx={{
                  display: 'flex',
                  mb: 2,
                  width: '100%'
                }}
                noValidate
                autoComplete="off"
              >
                <TextField
                  fullWidth
                  label="Imagen"
                  size="small"
                  value={imageState}
                  onChange={event => setImageState(event.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          variant="contained"
                          aria-label="upload"
                          component="label"
                          style={{
                            color: '#2A3F90'
                          }}
                          onClick={() => {
                            ImageInputRef.current.click();
                          }}
                        >
                          <PlagiarismOutlinedIcon />
                        </IconButton>
                        <input
                          ref={ImageInputRef}
                          type="file"
                          style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          onChange={event => {
                            loadFileToBack(event.target.files[0]);
                          }}
                        />
                      </InputAdornment>
                    )
                  }}
                />
              </Box>
            )}
            {renderField(
              'TextField',
              'createAnnotationButton',
              'Enter text for the create annotation button'
            )}
            {renderField(
              'TextField',
              'updateAnnotationButton',
              'Enter text for the updated annotation button'
            )}
            <Box
              component="form"
              sx={{
                display: 'flex',
                mb: 2,
                width: '100%'
              }}
              noValidate
              autoComplete="off"
            >
              <TextField
                id="outlined-required"
                label="Enter a title for the coordinates button"
                size="small"
                focused
                value={localSettings.buttonCurrentLocation.name}
                onChange={event => {
                  setSettingsAdvanced(prev => ({
                    ...prev,
                    locationSettings: {
                      ...prev.locationSettings,
                      buttonCurrentLocation: {
                        ...prev.locationSettings.buttonCurrentLocation,
                        name: event.target.value
                      }
                    }
                  }));
                  setLocalSettings({
                    ...localSettings,
                    buttonCurrentLocation: {
                      ...localSettings.buttonCurrentLocation,
                      name: event.target.value
                    }
                  });
                }}
                mb={2}
                fullWidth
              />
              <IconButton
                onClick={() => setOpenModalCurrentButton(true)}
                style={{
                  color: '#2A3F90'
                }}
              >
                {!isEmpty(localSettings.buttonCurrentLocation.libraryIcon) ? (
                  <>
                    {localSettings.buttonCurrentLocation.libraryIcon ===
                      LIBRARY_ICON_TYPES.FONTAWESOME && (
                      <FontAwesomeIcon icon={localSettings.buttonCurrentLocation.iconFontawesome} />
                    )}
                    {localSettings.buttonCurrentLocation.libraryIcon === LIBRARY_ICON_TYPES.SVG && (
                      <img
                        src={localSettings.buttonCurrentLocation.iconSvg}
                        alt={localSettings.buttonCurrentLocation.iconFontawesome}
                        style={{ marginRight: '5px', width: '20px', height: '20px' }}
                      />
                    )}
                  </>
                ) : (
                  <ShareIcon />
                )}
              </IconButton>
              <ShowListIconsFontawesome
                openModal={openModalCurrentButton}
                setOpenModal={setOpenModalCurrentButton}
                handleIconSelected={handleIconCurrentLocationSelected}
                selectedIcon={localSettings.buttonCurrentLocation.iconFontawesome}
                startLibrary={localSettings.buttonCurrentLocation.libraryIcon}
                svg={localSettings.buttonCurrentLocation.iconSvg}
                startCategorySvg={localSettings.buttonCurrentLocation.cetegorySvg}
              />
            </Box>
          </>
        )}
        <Box display="flex" alignItems="center" width="100%" mb={2}>
          <IconButton
            onClick={() => {
              setAnnotationState(!annotationState);
            }}
          >
            {annotationState ? <ExpandMoreIcon /> : <ExpandLessIcon />}
          </IconButton>
          <Typography variant="body1" sx={{ marginRight: 2 }}>
            Annotations
          </Typography>
          <Divider sx={{ flexGrow: 1, height: 1, backgroundColor: 'grey' }} />
        </Box>
        {annotationState === true && (
          <>
            {localSettings.typeComponent !== 'Simple' && (
              <>
                <Box
                  component="form"
                  sx={{
                    display: 'flex',
                    mb: 2,
                    width: '100%'
                  }}
                  noValidate
                  autoComplete="off"
                >
                  <Checkbox
                    checked={localSettings.buttonToAddImage.show}
                    onChange={() => {
                      const newShowValue = !localSettings.buttonToAddImage.show;
                      setLocalSettings(prev => ({
                        ...prev,
                        buttonToAddImage: {
                          ...prev.buttonToAddImage,
                          show: newShowValue
                        }
                      }));
                      setSettingsAdvanced(prev => ({
                        ...prev,
                        locationSettings: {
                          ...prev.locationSettings,
                          buttonToAddImage: {
                            ...prev.locationSettings.buttonToAddImage,
                            show: newShowValue
                          }
                        }
                      }));
                    }}
                    sx={{
                      color: '#2A3F90',
                      '&.Mui-checked': {
                        color: '#2A3F90'
                      }
                    }}
                    value="variable"
                  />
                  {localSettings.buttonToAddImage.show === true ? (
                    <>
                      <TextField
                        id="outlined-required"
                        label="Enter a title for the add image button"
                        size="small"
                        focused
                        value={localSettings.buttonToAddImage.name}
                        onChange={event => {
                          setSettingsAdvanced(prev => ({
                            ...prev,
                            locationSettings: {
                              ...prev.locationSettings,
                              buttonToAddImage: {
                                ...prev.locationSettings.buttonToAddImage,
                                name: event.target.value
                              }
                            }
                          }));
                          setLocalSettings({
                            ...localSettings,
                            buttonToAddImage: {
                              ...localSettings.buttonToAddImage,
                              name: event.target.value
                            }
                          });
                        }}
                        mb={2}
                        fullWidth
                      />
                      <IconButton
                        onClick={() => setOpenModalImageButton(true)}
                        style={{
                          color: '#2A3F90'
                        }}
                      >
                        {!isEmpty(localSettings.buttonToAddImage.libraryIcon) ? (
                          <>
                            {localSettings.buttonToAddImage.libraryIcon ===
                              LIBRARY_ICON_TYPES.FONTAWESOME && (
                              <FontAwesomeIcon
                                icon={localSettings.buttonToAddImage.iconFontawesome}
                              />
                            )}
                            {localSettings.buttonToAddImage.libraryIcon ===
                              LIBRARY_ICON_TYPES.SVG && (
                              <img
                                src={localSettings.buttonToAddImage.iconSvg}
                                alt={localSettings.buttonToAddImage.iconFontawesome}
                                style={{ marginRight: '5px', width: '20px', height: '20px' }}
                              />
                            )}
                          </>
                        ) : (
                          <ShareIcon />
                        )}
                      </IconButton>
                      <ShowListIconsFontawesome
                        openModal={openModalImageButton}
                        setOpenModal={setOpenModalImageButton}
                        handleIconSelected={handleIconToAddImageSelected}
                        selectedIcon={localSettings.buttonToAddImage.iconFontawesome}
                        startLibrary={localSettings.buttonToAddImage.libraryIcon}
                        svg={localSettings.buttonToAddImage.iconSvg}
                        startCategorySvg={localSettings.buttonToAddImage.cetegorySvg}
                      />
                    </>
                  ) : (
                    'Upload images'
                  )}
                </Box>
                <Box
                  component="form"
                  sx={{
                    display: 'flex',
                    mb: 2,
                    width: '100%'
                  }}
                  noValidate
                  autoComplete="off"
                >
                  <Checkbox
                    checked={localSettings.buttonToAddVideo.show}
                    onChange={() => {
                      const newShowValue = !localSettings.buttonToAddVideo.show;
                      setLocalSettings(prev => ({
                        ...prev,
                        buttonToAddVideo: {
                          ...prev.buttonToAddVideo,
                          show: newShowValue
                        }
                      }));
                      setSettingsAdvanced(prev => ({
                        ...prev,
                        locationSettings: {
                          ...prev.locationSettings,
                          buttonToAddVideo: {
                            ...prev.locationSettings.buttonToAddVideo,
                            show: newShowValue
                          }
                        }
                      }));
                    }}
                    sx={{
                      color: '#2A3F90',
                      '&.Mui-checked': {
                        color: '#2A3F90'
                      }
                    }}
                    value="variable"
                  />
                  {localSettings.buttonToAddVideo.show === true ? (
                    <>
                      <TextField
                        id="outlined-required"
                        label="Enter a title for the add videos button"
                        size="small"
                        focused
                        value={localSettings.buttonToAddVideo.name}
                        onChange={event => {
                          setSettingsAdvanced(prev => ({
                            ...prev,
                            locationSettings: {
                              ...prev.locationSettings,
                              buttonToAddVideo: {
                                ...prev.locationSettings.buttonToAddVideo,
                                name: event.target.value
                              }
                            }
                          }));
                          setLocalSettings({
                            ...localSettings,
                            buttonToAddVideo: {
                              ...localSettings.buttonToAddVideo,
                              name: event.target.value
                            }
                          });
                        }}
                        mb={2}
                        fullWidth
                      />
                      <IconButton
                        onClick={() => setOpenModalVideoButton(true)}
                        style={{
                          color: '#2A3F90'
                        }}
                      >
                        {!isEmpty(localSettings.buttonToAddVideo.libraryIcon) ? (
                          <>
                            {localSettings.buttonToAddVideo.libraryIcon ===
                              LIBRARY_ICON_TYPES.FONTAWESOME && (
                              <FontAwesomeIcon
                                icon={localSettings.buttonToAddVideo.iconFontawesome}
                              />
                            )}
                            {localSettings.buttonToAddVideo.libraryIcon ===
                              LIBRARY_ICON_TYPES.SVG && (
                              <img
                                src={localSettings.buttonToAddVideo.iconSvg}
                                alt={localSettings.buttonToAddVideo.iconFontawesome}
                                style={{ marginRight: '5px', width: '20px', height: '20px' }}
                              />
                            )}
                          </>
                        ) : (
                          <ShareIcon />
                        )}
                      </IconButton>
                      <ShowListIconsFontawesome
                        openModal={openModalVideoButton}
                        setOpenModal={setOpenModalVideoButton}
                        handleIconSelected={handleIconToAddVideoSelected}
                        selectedIcon={localSettings.buttonToAddVideo.iconFontawesome}
                        startLibrary={localSettings.buttonToAddVideo.libraryIcon}
                        svg={localSettings.buttonToAddVideo.iconSvg}
                        startCategorySvg={localSettings.buttonToAddVideo.cetegorySvg}
                      />
                    </>
                  ) : (
                    'Upload videos'
                  )}
                </Box>
                <Box
                  component="form"
                  sx={{
                    display: 'flex',
                    mb: 2,
                    width: '100%'
                  }}
                  noValidate
                  autoComplete="off"
                >
                  <Checkbox
                    checked={localSettings.buttonToAddIframe.show}
                    onChange={() => {
                      const newShowValue = !localSettings.buttonToAddIframe.show;
                      setLocalSettings(prev => ({
                        ...prev,
                        buttonToAddIframe: {
                          ...prev.buttonToAddIframe,
                          show: newShowValue
                        }
                      }));
                      setSettingsAdvanced(prev => ({
                        ...prev,
                        locationSettings: {
                          ...prev.locationSettings,
                          buttonToAddIframe: {
                            ...prev.locationSettings.buttonToAddIframe,
                            show: newShowValue
                          }
                        }
                      }));
                    }}
                    sx={{
                      color: '#2A3F90',
                      '&.Mui-checked': {
                        color: '#2A3F90'
                      }
                    }}
                    value="variable"
                  />
                  {localSettings.buttonToAddIframe.show === true ? (
                    <>
                      <TextField
                        id="outlined-required"
                        label="Enter a title for the add iframe button"
                        focused
                        size="small"
                        value={localSettings.buttonToAddIframe.name}
                        onChange={event => {
                          setSettingsAdvanced(prev => ({
                            ...prev,
                            locationSettings: {
                              ...prev.locationSettings,
                              buttonToAddIframe: {
                                ...prev.locationSettings.buttonToAddIframe,
                                name: event.target.value
                              }
                            }
                          }));
                          setLocalSettings({
                            ...localSettings,
                            buttonToAddIframe: {
                              ...localSettings.buttonToAddIframe,
                              name: event.target.value
                            }
                          });
                        }}
                        mb={2}
                        fullWidth
                      />
                      <IconButton
                        onClick={() => setOpenModalIframeButton(true)}
                        style={{
                          color: '#2A3F90',
                          size: 'small'
                        }}
                      >
                        {!isEmpty(localSettings.buttonToAddIframe.libraryIcon) ? (
                          <>
                            {localSettings.buttonToAddIframe.libraryIcon ===
                              LIBRARY_ICON_TYPES.FONTAWESOME && (
                              <FontAwesomeIcon
                                icon={localSettings.buttonToAddIframe.iconFontawesome}
                              />
                            )}
                            {localSettings.buttonToAddIframe.libraryIcon ===
                              LIBRARY_ICON_TYPES.SVG && (
                              <img
                                src={localSettings.buttonToAddIframe.iconSvg}
                                alt={localSettings.buttonToAddIframe.iconFontawesome}
                                style={{ marginRight: '5px', width: '20px', height: '20px' }}
                              />
                            )}
                          </>
                        ) : (
                          <ShareIcon />
                        )}
                      </IconButton>
                      <ShowListIconsFontawesome
                        openModal={openModalIframeButton}
                        setOpenModal={setOpenModalIframeButton}
                        handleIconSelected={handleIconToAddIframeSelected}
                        selectedIcon={localSettings.buttonToAddIframe.iconFontawesome}
                        startLibrary={localSettings.buttonToAddIframe.libraryIcon}
                        svg={localSettings.buttonToAddIframe.iconSvg}
                        startCategorySvg={localSettings.buttonToAddIframe.cetegorySvg}
                      />
                    </>
                  ) : (
                    'Upload videos'
                  )}
                </Box>
                {renderField('checkBox', 'trackingAnnotation', 'Anotación con seguimiento')}
                <Box display="row" justifyContent="space-evenly" fullwidth="true" mb={2}>
                  <Switch
                    checked={localSettings.updatedAnnotation}
                    onChange={() => {
                      setSettingsAdvanced(prev => ({
                        ...prev,
                        locationSettings: {
                          ...prev.locationSettings,
                          updatedAnnotation: !localSettings.updatedAnnotation
                        }
                      }));
                      setLocalSettings({
                        ...localSettings,
                        updatedAnnotation: !localSettings.updatedAnnotation
                      });
                    }}
                    sx={{
                      '& .MuiSwitch-switchBase': {
                        color: '#2A3F90',
                        '&.Mui-checked': {
                          color: '#2A3F90'
                        },
                        '&.Mui-checked + .MuiSwitch-track': {
                          backgroundColor: '#2A3F90',
                          border: '2px solid #2A3F90'
                        }
                      },
                      '& .MuiSwitch-thumb': {
                        border: '2px solid #2A3F90'
                      },
                      '& .MuiSwitch-track': {
                        backgroundColor: '#ffffff',
                        border: '2px solid #2A3F90',
                        opacity: 1
                      }
                    }}
                  />
                  {localSettings.updatedAnnotation === true
                    ? 'Actualizar la anotación tras crearla'
                    : 'Crear una anotación nueva'}
                </Box>
                {localSettings.typeComponent === 'Complex' &&
                  renderField(
                    'checkBox',
                    'changeTemplate',
                    'Cambiar plantilla dentro del componente'
                  )}
                {localSettings.typeComponent !== 'Simple' &&
                  renderField('checkBox', 'sendFirstLocation', 'Send location on startup')}
                {(localSettings.typeComponent === 'MediumWith' ||
                  localSettings.typeComponent === 'Complex') &&
                  renderField(
                    'checkBox',
                    'goToCurrentLocation',
                    'Focus on your location at startup'
                  )}
                {localSettings.typeComponent !== 'Simple' &&
                  renderField(
                    'checkBox',
                    'showAddress',
                    'Mostrar dirección cuando se selecciona un punto del mapa'
                  )}
                {localSettings.typeComponent !== 'Simple' &&
                  renderField('checkBox', 'searchAddress', 'Search address')}
              </>
            )}
          </>
        )}
      </Box>
    </Box>
  );
};
export default withTracker(({ settingsAdvanced }) => {
  const { videoId } = settingsAdvanced.locationSettings;
  const projectsSub = Meteor.subscribe('projects');
  const videosSub = Meteor.subscribe('videos.maps');

  let loading = !videosSub.ready() || !projectsSub.ready();

  const projectList = Projects.find({ deleted: { $eq: 'no' } }, { sort: { name: 1 } }).fetch();
  const videoList = Videos.find({}, { sort: { name: 1 } }).fetch();
  let annotationTemplateSub = {};
  let annotationTemplateCustomList = [];
  const video = Videos.findOne({ _id: videoId });
  if (!isEmpty(video)) {
    annotationTemplateSub = Meteor.subscribe(
      'annotationTemplatesCustom.manyVideos',
      videoOps.getAnnotationTemplatesCustom(video)
    );
    annotationTemplateCustomList = AnnotationTemplatesCollection.find({
      deleted: { $eq: 'no' }
    }).fetch();
    loading = loading || !annotationTemplateSub.ready();
  }

  return {
    loading,
    annotationTemplateCustomList,
    projectList,
    videoList
  };
})(MapsAdvancedLocationField);

MapsAdvancedLocationField.defaultProps = {
  setListComponentsAdvanced: () => {},
  annotationTemplateCustomList: [],
  loading: false
};
MapsAdvancedLocationField.propTypes = {
  listComponentsAdvanced: PropTypes.object.isRequired,
  setListComponentsAdvanced: PropTypes.func,
  videoList: PropTypes.array.isRequired,
  projectList: PropTypes.array.isRequired,
  settingsAdvanced: PropTypes.object.isRequired,
  setSettingsAdvanced: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  setSizeDrawer: PropTypes.func.isRequired,
  annotationTemplateCustomList: PropTypes.array
};
